import * as React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import MenuIcon from '@mui/icons-material/Menu';

class SmallMenu extends React.Component {

    constructor(props) {
      super(props);
  
      this.state = {
        menuOpenState: false,
        anchorReference: 'anchorEl'
      };

      this.toggleOpenMenu = this.toggleOpenMenu.bind(this);
    }
  
    componentDidMount() {
    }
  
    componentDidUpdate() { 
      //window.removeEventListener('load', this.handleLoad)  
    } 
  
    toggleOpenMenu ( ) {
      let menuState = this.state.menuOpenState;
      this.setState ( {menuOpenState: !menuState} );
      this.props.toggleSmallMenu (!menuState);
    }
  

    render() {
    return (
        <Stack direction="row" spacing={2}>
        <div>
            <Button
            id="composition-button"
            aria-haspopup="true"
            onClick={this.toggleOpenMenu}
            >
            <MenuIcon />
            </Button>
        </div>
        </Stack>
    );
        }
}

export default SmallMenu;
